import React, { type SyntheticEvent } from 'react';
import { VIEW_KIND_SECTION } from '@jira/polaris__domain-view/src/viewKindTimeline.constants.tsx';
import { token } from '@atlaskit/tokens';
import ButtonItem from '@atlaskit/menu/button-item';

import { defineMessage, useIntl } from '@atlassian/jira-intl';
import { ViewItemIcon } from '../../view-item-icon/index.tsx';
import { useViewsetsEntityLimitType } from '../../../controllers/context.tsx';

const createNewSection = defineMessage({
	id: 'navigation-apps-sidebar-nav4-sidebars-common-jpd-nav-views.create-view-menu.menu.create-new-section',
	defaultMessage: 'Section',
	description: 'Dropdown option to create a new JPD section',
});

type BasicViewSetsProps = {
	createViewHandlers: {
		readonly SECTION: (event: SyntheticEvent) => void;
	};
	hasReachedViewsetsLimit?: number | null;
};

export const BasicViewSets = ({
	createViewHandlers,
	hasReachedViewsetsLimit,
}: BasicViewSetsProps): React.JSX.Element | null => {
	const viewsetsEntityLimitType = useViewsetsEntityLimitType();
	const { formatMessage } = useIntl();

	if (!viewsetsEntityLimitType) {
		return null;
	}

	return (
		<ButtonItem
			// eslint-disable-next-line jira/integration/test-id-by-folder-structure
			testId="navigation-apps-sidebar-nav4-sidebars-common-jpd-nav-views.ui.create-view-menu.menu.section"
			onClick={createViewHandlers[VIEW_KIND_SECTION]}
			isDisabled={!!hasReachedViewsetsLimit}
			iconBefore={
				<ViewItemIcon
					viewKind={VIEW_KIND_SECTION}
					color={hasReachedViewsetsLimit ? token('color.icon.disabled') : undefined}
					label=""
				/>
			}
		>
			{formatMessage(createNewSection)}
		</ButtonItem>
	);
};
